import type { PolicyData } from 'ts/types/get-policies.types';
import { createAction, getActionList } from './action-utils';
import { GET_POLICIES_FAIL, GET_POLICIES_SUCCESS, GET_POLICIES } from './types';

const actions = {
  getPolicies: () => createAction(GET_POLICIES, {}),
  getPoliciesFail: () => createAction(GET_POLICIES_FAIL, {}),
  getPoliciesSuccess: (payload: PolicyData) =>
    createAction(GET_POLICIES_SUCCESS, payload),
};

export default actions;

const actionList = getActionList(actions);

export type GetPoliciesActionType = typeof actionList[number];
